AuthRoute = require 'mixins/authenticated-route'

App.DeliveryZonesRoute = Em.Route.extend AuthRoute,
  session: Em.inject.service()

  beforeModelAuth: ->
    promise = null

    promise = if @get('session.currentUser.isStaffMember')
      organization = @get('session').get('currentOrganization')
      @controllerFor('delivery.zones').set('organization', organization)

      @store.find('restaurant', {organization_id: organization.get('id')})
    else if @get('session.currentUser.isLogisticsStaff')
      @store.find('restaurant')
    else
      Em.RSVP.reject('Wrong context!')

    promise.then (restaurants) =>
      @controllerFor('delivery').set('restaurants', restaurants)

  model: ->
    modelPromise = if @get('session.currentUser.isStaffMember')
      organization = @get('session').get('currentOrganization')
      @store.find('delivery-zone', organization_id: organization.get('id'))
    else if @get('session.currentUser.isLogisticsStaff')
      @store.find('delivery-zone')

  renderTemplate: (controller, model) ->
    @render 'delivery.zones.sidebar',
      outlet: 'sidebar',
      controller: controller

    @render 'delivery.zones.content',
      controller: controller

  actions:
    didTransition: ->
      controller = @get('controller')
      controller.set('isEditing', false)

    startEditing: (zone) ->
      controller = @controllerFor('delivery.zones')

      if controller.get('zones').indexOf(zone) is -1
        controller.get('zones').pushObject(zone)

      if controller.get('selectedZone') != zone
        controller.set('selectedZone', zone)

      controller.set('isEditing', true)
      false

